<template>
  <div class="main-box" >
  	<!--<img src="@/assets/images/home.png"></img>-->
  	<!--<div id="particles-js"  style="position: absolute;bottom:0px; left:0px;width:100%;height:70vh;box-sizing:border-box;"></div>-->
  	<div id="particles"  style="position: absolute;bottom:0px; left:0px;width:100%;height:100vh;box-sizing:border-box;"></div>
  	<div class="home" v-if="showindex" @click="goindex">
  		
  		<a-icon type="home" theme="filled" />
  		首页
  	</div>
  	<div style="position: relative;margin: 0px auto;width:1300px;box-sizing:border-box;padding-top: 128px;">
    <div class="main-title">数字化转型赋能职业教育高质量发展</div>
    <div class="main-headline">
      <img src="@/assets/images/new/title-text.png" alt="">
    </div>
    <div>
      <router-view />
    </div>
    </div>
    <!-- 弹出层 -->
    <!--<div class="loginPop flex flex-center align-items-end" v-if="showLoginPop">
      <login @close="close" @loginSuccess="showLoginPop = false"></login>
    </div>-->
     <!--<canvas ref="myCanvas"></canvas>-->
    <!--<a-affix v-if="showdown" style="width:30px;height:233px; position: fixed;right:10px;top:50vh;">
        <div class="a-tip flex flex-col flex-between">
          <div class="link">申报下载</div>
        </div>
    </a-affix>-->
  </div>
</template>

<script>
import foot from "../../components/footer";
import login from "../../components/login";
import {initializeParticleEffect} from "@/utils/dh"
export default {
  name: "Home",
  components: {
    foot,
    login,
  },
  beforeRouteEnter(to,from,next){
		next((vm)=>{
				if(to.path!='/home/index1' && to.path!='/home/index'){
				    vm.showindex=true;
				}else{
				  	vm.showindex=false;
				}
			if(to.path=='/home/login/2' || to.path=='/home/index1'){
      	vm.showdown=true;
      }else{
      	vm.showdown=false;
      }
		});
  },
  watch:{
  	$route(to,form){
		if(to.path!='/home/index1' && to.path!='/home/index'){
      	 	this.showindex=true;
      }else{
      	 	this.showindex=false;
     }
      if(to.path=='/home/login/2' || to.path=='/home/index1'){
      	this.showdown=true;
      }else{
      	this.showdown=false;
      }
  	}
  },
  data() {
    return {
    	showdown:false,
    	showindex:false,
      showLoginPop: false,
      list: [
        {
          title: "首页",
          icon: require("../../assets/images/img7.png"),
          activeImg: require("../../assets/images/img18.png"),
          path: "/home/index",
          name: "Index",
        },
        {
          title: "申报指南",
          icon: require("../../assets/images/img5.png"),
          activeImg: require("../../assets/images/img16.png"),
          path: "/home/guide",
          name: "Guide",
        },
        {
          title: "文件下载",
          icon: require("../../assets/images/img6.png"),
          activeImg: require("../../assets/images/img13.png"),
          path: "/home/downLoad",
          name: "DownLoad",
        },
      ],
    };
  },
  mounted(){
			initializeParticleEffect();
  },
  methods: {
  	goindex(){
  		this.$router.push({path:'/home/index1'});
  	},
    jumpPage(i) {
      this.$router.push(this.list[i].path);
    },
    close() {
      this.showLoginPop = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/mixin.scss";

.main-box {
	width:100%;
  min-height: 100vh;
  /*background: url("~@/assets/images/new/background.jpg") no-repeat;*/
  background: url("~@/assets/images/bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: auto;
  position: relative;
  box-sizing: border-box;
  overflow:hidden;
  .main-title {
    background: url("~@/assets/images/new/title-img.png") no-repeat center
      center;
    background-size: auto auto;
    text-align: center;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
  .main-headline{
    text-align: center;
    margin-top: 26px;
  }
}
.loginPop {
  position: relative;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.52);
}
.home{
    width: 86px;
    height: 30px;
		background: rgba(255,255,255,0.2);
		border: 1px solid #1B42CB;
		border-radius: 4px;
		position: absolute;
		top:20px;
		right:100px;
		display: flex;
		padding:0px 10px;
		box-sizing: border-box;
		justify-content: space-around;
		align-items: center;
		cursor: pointer;
    z-index:111;
		/*img{
			width:13px;
			height:13px;
		}*/
}
.a-tip {
    height: 233px;
    width: 30px;
    /*position: absolute;*/
    margin: 0;
    z-index: 1;
    .link {
      display:inline-block;
      height: 110px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      cursor: pointer;
      padding: 10px 0;
      padding-left: 7px;
      background: #fcc485;
      color: #b25d24;
    }
    .link:hover,
    .link.router-link-exact-active{
      background: #023b9d;
      color: #fff;
    }
  }
</style>
